<template>
  <div>
    <b-row class="m-3">
      <b-col lg="6">
        <div class="tiptap-style p-3">
          <editor-menu-bar
            class="mb-2"
            :editor="editor"
            v-slot="{ commands, isActive }"
          >
            <div class="menubar">
              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.bold() }"
                @click="commands.bold"
              >
                <b-icon-type-bold></b-icon-type-bold>
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.italic() }"
                @click="commands.italic"
              >
                <b-icon-type-italic></b-icon-type-italic>
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.strike() }"
                @click="commands.strike"
              >
                <b-icon-type-strikethrough></b-icon-type-strikethrough>
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.underline() }"
                @click="commands.underline"
              >
                <b-icon-type-underline></b-icon-type-underline>
              </button>
              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                @click="commands.heading({ level: 1 })"
              >
                H1
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                @click="commands.heading({ level: 2 })"
              >
                H2
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                @click="commands.heading({ level: 3 })"
              >
                H3
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 4 }) }"
                @click="commands.heading({ level: 4 })"
              >
                H4
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 5 }) }"
                @click="commands.heading({ level: 5 })"
              >
                H5
              </button>
            </div>
          </editor-menu-bar>

          <editor-content class="editor__content" :editor="editor" />
        </div>
        <div class="text-right mt-3">
          <b-button
            size="sm"
            class="px-4 mr-2"
            variant="danger"
            :disabled="html.length === 7 ? true : false"
            @click="saveData(html)"
            >Save</b-button
          >
          <b-button
            size="sm"
            class="px-3"
            variant="outline-danger"
            @click="cancel"
            >Discard</b-button
          >
        </div>
      </b-col>
      <b-col lg="6">
        <div class="editor-content" v-html="html" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions'
export default {
  components: {
    EditorContent,
    EditorMenuBar,
  },
  props: {
    cancel: {
      type: Function,
    },
    saveData: {
      type: Function,
    },
    data: {
      type: String,
    },
  },
  data() {
    return {
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3, 4, 5] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
        ],
        content: this.data,
        onUpdate: ({ getHTML }) => {
          this.html = getHTML()
        },
      }),
      html: this.data,
    }
  },
  methods: {
    clearContent() {
      this.editor.clearContent(true)
      this.editor.focus()
    },
    setContent() {
      // you can pass a json document
      this.editor.setContent(
        {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  type: 'text',
                  text: 'This is some inserted text. 👋',
                },
              ],
            },
          ],
        },
        true
      )
      // HTML string is also supported
      // this.editor.setContent('<p>This is some inserted text. 👋</p>')
      this.editor.focus()
    },
  },
}
</script>
<style scoped>
.tiptap-style {
  border: 1px solid #b1b4b6;
  border-radius: 5px;
}
.editor__content {
  background-color: lavender;
  padding: 10px;
}
</style>
